const calendarOverride = function(moment) {
  moment.updateLocale('pt-br', {
    calendar: {
      lastDay: '[Ontem]',
      sameDay: '[Hoje]',
      nextDay: '[Amanhã]',
      lastWeek: 'DD/MM',
      nextWeek: 'DD/MM',
      sameElse: 'DD/MM',
    },
  })
}

export default function setup(Vue) {
  const moment = require('moment')
  // languages
  require('moment/locale/pt-br')

  // override some confs from calendar
  calendarOverride(moment)

  Vue.use(require('vue-moment'), {
    moment,
  })
}
